export enum TYPES {
    Activated = "activated",
    Imported = "imported"
}
